import { option, record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { HoursParameters } from '@mews-commander/data-access';
import { Hour } from '@mews/enums';
import { DateTimeLocalizationInfo, TimeService } from '@mews/framework';
import { padStartZero } from '@optimus-web/core';

export const convertHoursToTrueValuesObject = (hours: string[], localization: DateTimeLocalizationInfo) => {
    const trueValuesObject = hours.reduce((acc: Record<string, boolean>, hour: string) => {
        const hourNumber = TimeService.fromShortString(hour, localization);
        const hourValue = Object.values(Hour).indexOf(TimeService.getHours(hourNumber));
        const hourKey = Object.keys(Hour)[hourValue];
        return { ...acc, [hourKey]: true };
    }, {});
    return { ...defaultFalseHourObject, ...trueValuesObject };
};

export const convertTrueValuesToHoursObject = (hours: HoursParameters, localization: DateTimeLocalizationInfo) =>
    Object.keys(hours)
        .filter((key) => hours[key as keyof HoursParameters])
        .map((key) => {
            // @ts-expect-error
            const hour = Hour[key];
            const srtTime = `${padStartZero(hour)}:00:00`;
            const time = TimeService.parse(srtTime);
            return TimeService.toShortString(time, localization);
        });

const defaultFalseHourObject = pipe(
    Hour,
    record.filterMap((value) => {
        if (typeof value === 'number') {
            return option.some(false);
        }
        return option.none;
    })
) as unknown as HoursParameters;
